module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav-bar'), _vm._v(" "), _c('div', {
    staticClass: "pt-4 mx-3"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h3', {
    staticClass: "my-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('logs.title')))])]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "filterResults",
      "hide-single-page": true,
      "limit": 5
    },
    on: {
      "change": _vm.setLastPage
    }
  }), _vm._v(" "), _c('paginate', {
    ref: "paginator",
    attrs: {
      "refreshCurrentPage": false,
      "name": "filterResults",
      "tag": "div",
      "list": _vm.filterResults,
      "per": 30
    }
  }, [(_vm.reversedLogs.length > 0) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover font-grey mb-0 table-sm"
  }, [_c('thead', {
    staticClass: "bg-darkgrey"
  }, [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('logs.table_header.user')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('logs.table_header.action')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('logs.table_header.date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('logs.table_header.target')))])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade",
      "tag": "tbody"
    }
  }, [_c('tr', {
    key: "filter"
  }, [_c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.userName,
      "placeholder": _vm.$t('logs.table_header.user')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('userName', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.action,
      "placeholder": _vm.$t('logs.table_header.action')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('action', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.date,
      "placeholder": _vm.$t('logs.table_header.date')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('date', $event)
      }
    }
  })], 1), _vm._v(" "), _c('td', [_c('regular-input', {
    attrs: {
      "value": _vm.fields.target,
      "placeholder": _vm.$t('logs.table_header.target')
    },
    on: {
      "input": function($event) {
        _vm.evaluateFiltering('target', $event)
      }
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.paginated('filterResults')), function(log) {
    return _c('tr', {
      key: log['.key']
    }, [_c('td', [_vm._v(_vm._s(_vm.getUserName(log.UID)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('logs.action.' + log.action)) + _vm._s(log.status ? ': ' + log.status : '') + _vm._s(log.targetName ? ': ' + log.targetName : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getDate(log.date)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(log.orderID || log.modifiedUserName || log.customerName || log.targetName || log.createdUserName))])])
  })], 2)], 1)]) : _vm._e()]), _vm._v(" "), _c('paginate-links', {
    attrs: {
      "for": "filterResults",
      "hide-single-page": true,
      "limit": 5
    },
    on: {
      "change": _vm.setLastPage
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e9ad9ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Logs.vue
// module id = 843
// module chunks = 1